import { DateTime, Duration } from "luxon";
import { JobDetailsService } from "../../models";

export interface JobLocation {
    id?: string;
    locationId?: string;
    locationName?: string;
    template?:string;
    latitude?: number;
    longitude?: number;
    address?: string;
    postalCode?: string;
    city?: string;
    country?: string;
    stopTime?: string;
    serviceTime?: string;
    pickupCapacityType1?: number;
    pickupCapacityType2?: number;
    pickupCapacityType3?: number;
    deliveryCapacityType1?: number;
    deliveryCapacityType2?: number;
    deliveryCapacityType3?: number;
    precedence?: number;
    qualifications?: string;
    stopNumber?: number;
    sequenceNumber?: number;
    jobNumber?: string;
    planName?: string;
    planId?: string;
    jobId?: string;
    arrivalTime?: DateTime;
    departureTime?:DateTime;
    customData?: string;
    servicesCount?: number;
    createdAt?: DateTime;
    priority?: number;
    distributionLaneId? : string;
    isScheduled?: boolean;
    services?: JobDetailsService[];
    isEndTerminal? : boolean;
    isStartTerminal? : boolean;
    openHours?:string;
    IsUnAssignedLocation : boolean;
    segment?:string;
    isChecked?: boolean;
  }
  